import produce from 'immer';
import {State, Actions} from './interfaces';
import {
  GET_USERS,
  GET_USERS_SUCCESS,
  GET_USERS_FAILED,
  GET_USERS_WITH_ID,
  GET_USERS_WITH_ID_SUCCESS,
  GET_USERS_WITH_ID_FAILED,
  CREATE_USER,
  CREATE_USER_FAILED,
  CREATE_USER_SUCCESS,
  UPDATE_USER_STATUS,
  UPDATE_USER_STATUS_FAILED,
  UPDATE_USER_STATUS_SUCCESS,
  UPDATE_USER,
  UPDATE_USER_FAILED,
  UPDATE_USER_SUCCESS,
  GET_CUSTOMERS_SUCCESS,
  GET_CUSTOMERS_FAILED,
  GET_ORGANS_SUCCESS,
  GET_ORGANS_FAILED,
} from './constants';

export const initialState: State = {
  usersList: [],
  user: [],
  count: 0,
  loading: false,
  error: '',
  customersList: [],
  organsList: [],
};

export const UsersReducer = (state = initialState, action: Actions) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_USERS:
        draft.loading = true;
        break;
      case GET_USERS_SUCCESS:
        draft.usersList = action.data;
        draft.count = action.count;
        draft.loading = false;
        break;
      case GET_USERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;
      case GET_ORGANS_SUCCESS:
        draft.organsList = action.data;
        draft.loading = false;
        break;
      case GET_ORGANS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;
      case GET_CUSTOMERS_SUCCESS:
        draft.customersList = action.data;
        draft.count = action.count;
        draft.loading = false;
        break;
      case GET_CUSTOMERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;
      case GET_USERS_WITH_ID:
        draft.loading = true;
        break;
      case GET_USERS_WITH_ID_SUCCESS:
        draft.user = action.data;
        draft.loading = false;
        break;
      case GET_USERS_WITH_ID_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case CREATE_USER:
      case UPDATE_USER:
      case UPDATE_USER_STATUS:
        draft.loading = true;
        draft.error = '';
        break;
      case CREATE_USER_SUCCESS:
      case UPDATE_USER_SUCCESS:
      case UPDATE_USER_STATUS_SUCCESS:
        draft.loading = false;
        break;
      case CREATE_USER_FAILED:
      case UPDATE_USER_FAILED:
      case UPDATE_USER_STATUS_FAILED:
        draft.error = action.error.data;
        draft.loading = false;
        break;
      default:
        break;
    }
  });
export default UsersReducer;
